function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  fillRule: "evenodd"
}, React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 19.5,
  stroke: "#FFF",
  fill: "none"
}), React.createElement("path", {
  fillRule: "nonzero",
  d: "M24.403 17H22v-2c0-1.032.084-1.682 1.563-1.682h.868a1 1 0 001-1v-1.254c0-.523-.401-.97-.923-1.005A26.154 26.154 0 0022.693 10C19.98 10 18 11.657 18 14.699V17h-2a1 1 0 00-1 1v2a1 1 0 001 1l2-.001V29a1 1 0 001 1h2a1 1 0 001-1v-8.003l2.174-.001a1 1 0 00.993-.886l.229-1.996A1 1 0 0024.403 17z"
}));

function SvgFbinline(props) {
  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40"
  }, props), _ref);
}

export default SvgFbinline;